<template>
  <div class="guide-page-warp">
    <div class="guide-page-body">
      <template v-if="index === 0">
        <div class="guide-page-title">{{ i18n.works }}</div>
        <div>{{ i18n.works_tips1 }}</div>
        <div>{{ i18n.works_tips2 }}</div>
        <div>{{ i18n.works_tips3 }}</div>
        <div>{{ i18n.works_tips4 }}</div>
        <div>{{ i18n.works_tips5 }}</div>
        <img class="guide-page-img" src="@/assets/imgs/img_guide.png" alt="">
        <div>{{ i18n.works_tips6 }}</div>
        <div style="padding-top: 10px;">{{ i18n.works_tips7 }}</div>
      </template>
      <template v-else-if="index === 1">
        <div class="guide-page-title">{{ i18n.prices }}</div>
        <table v-if="cabinet && cabinet.priceStrategy && cabinet.priceStrategy.priceStrategyDetail && cabinet.priceStrategy.priceStrategyDetail.length > 0" class="guide-page-table">
          <tr v-for="(item, i) in cabinet.priceStrategy.priceStrategyDetail" :key="i">
            <td v-if="i === 0 || i === 1">{{ `${i18n.first_hours}`.format({ horas: item.pEndMinute / 60 }) }}</td>
            <td v-else>{{ `${i18n.between_hours}`.format({ horas1: item.pStartMinute / 60, horas2: item.pEndMinute / 60 }) }}</td>
            <td>{{ cabinet.currencyName }} {{ $money(item.pTotalFee) }}</td>
          </tr>
          <!-- <tr>
              <td>{{ time2 }}</td>
              <td>{{ cabinet.currencyName }} {{ $money(prices2) }}</td>
          </tr>
          <tr>
              <td>{{ time3 }}</td>
              <td>{{ cabinet.currencyName }} {{ $money(prices3) }}</td>
          </tr> -->
        </table>
        <div v-else-if="cabinet" style="padding: 10px 0;">
          {{ `${$t('home.price_info')}`.format(cabinet) }}
        </div>
        <div>{{ shopDesc }}</div>
        <div style="padding-top: 10px;">{{ shopDesc2 }}</div>
      </template>
    </div>
    <div class="guide-page-bottom">
      <img class="guide-page-btn" src="@/assets/imgs/icon_next2.png" alt="" @click="onNext">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['cabinet']),
    i18n() {
      return this.$t('guide')
    },
    shopDesc() {
      return `${this.i18n.price_tips1}`.format(this.cabinet)
    },
    shopDesc2() {
      return `${this.i18n.price_tips2}`.format({ overTime: this.cabinet.priceStrategy.pOvertimeDay })
    },
    time1() {
      return `${this.i18n.first_hours}`.format({ horas: this.firstHours })
    },
    time2() {
      return `${this.i18n.first_hours}`.format({ horas: this.betweenHours1 })
    },
    time3() {
      return `${this.i18n.between_hours}`.format({ horas1: this.betweenHours1, horas2: this.betweenHours2 })
    }
  },
  data () {
    return {
      index: 0,
      overTime: 2,
      firstHours: 2,
      betweenHours1: 4,
      betweenHours2: 48,
      prices1: 2500,
      prices2: 750,
      prices3: 5500
    }
  },
  methods: {
    onNext () {
      if (!this.cabinet) {
        this.$emit('change')
      } else if (this.index < 1) {
        this.index++
      } else {
        this.$emit('change')
      }
    }
  },
  created() {
    // try {
    //   if (this.cabinet && this.cabinet.priceStrategy) {
    //     let temp = this.cabinet.priceStrategy.priceStrategyDetail
    //     console.log('temp', temp)
    //     this.firstHours = temp[0].pEndMinute / 60
    //     this.overTime = temp[temp.length - 1].pEndMinute / 60
    //     this.betweenHours1 = temp[temp.length - 1].pStartMinute / 60
    //     this.betweenHours2 = temp[temp.length - 1].pEndMinute / 60
    //     this.prices1 = temp[0].pTotalFee
    //     this.prices2 = temp[1].pSetcionFee
    //     this.prices3 = temp[temp.length - 1].pTotalFee
    //   }
    // } catch (error) {
    //   console.log(error)
    // }
  }
}
</script>

<style lang="less">
.guide-page-warp {
  height: 100vh;
  background: #fff;
  .guide-page-body {
    padding: 40px;
  }
  .guide-page-title {
    font-size: 36px;
    font-weight: 600;
  }
  .guide-page-img {
    width: 60%;
    display: block;
    margin: 40px auto;
  }
  .guide-page-bottom {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 50px;
    display: flex;
    justify-content: center;
    .guide-page-btn {
      width: 90px;
    }
  }
  .guide-page-table {
    margin: 10px 0 30px;
    border-collapse: collapse;
    width: 100%;
    text-align: left;
    font-weight: 600;
    tr,td {
      border: 1px solid;
      padding: 20px 20px;
    }

  }
}
</style>
